const countries = [
    {
        "COUNTRY":"Afghanistan",
        "A2":"AF",
        "A3":"AFG",
        "NUM":4,
        "DIALINGCODE":"93"
    },
    {
        "COUNTRY":"Albania",
        "A2":"AL",
        "A3":"ALB",
        "NUM":8,
        "DIALINGCODE":"355"
    },
    {
        "COUNTRY":"Algeria",
        "A2":"DZ",
        "A3":"DZA",
        "NUM":12,
        "DIALINGCODE":"213"
    },
    {
        "COUNTRY":"American Samoa",
        "A2":"AS",
        "A3":"ASM",
        "NUM":16,
        "DIALINGCODE":"1-684"
    },
    {
        "COUNTRY":"Andorra",
        "A2":"AD",
        "A3":"AND",
        "NUM":20,
        "DIALINGCODE":"376"
    },
    {
        "COUNTRY":"Angola",
        "A2":"AO",
        "A3":"AGO",
        "NUM":24,
        "DIALINGCODE":"244"
    },
    {
        "COUNTRY":"Anguilla",
        "A2":"AI",
        "A3":"AIA",
        "NUM":660,
        "DIALINGCODE":"1-264"
    },
    {
        "COUNTRY":"Antarctica",
        "A2":"AQ",
        "A3":"ATA",
        "NUM":10,
        "DIALINGCODE":"672"
    },
    {
        "COUNTRY":"Antigua and Barbuda",
        "A2":"AG",
        "A3":"ATG",
        "NUM":28,
        "DIALINGCODE":"1-268"
    },
    {
        "COUNTRY":"Argentina",
        "A2":"AR",
        "A3":"ARG",
        "NUM":32,
        "DIALINGCODE":"54"
    },
    {
        "COUNTRY":"Armenia",
        "A2":"AM",
        "A3":"ARM",
        "NUM":51,
        "DIALINGCODE":"374"
    },
    {
        "COUNTRY":"Aruba",
        "A2":"AW",
        "A3":"ABW",
        "NUM":533,
        "DIALINGCODE":"297"
    },
    {
        "COUNTRY":"Australia",
        "A2":"AU",
        "A3":"AUS",
        "NUM":36,
        "DIALINGCODE":"61"
    },
    {
        "COUNTRY":"Austria",
        "A2":"AT",
        "A3":"AUT",
        "NUM":40,
        "DIALINGCODE":"43"
    },
    {
        "COUNTRY":"Azerbaijan",
        "A2":"AZ",
        "A3":"AZE",
        "NUM":31,
        "DIALINGCODE":"994"
    },
    {
        "COUNTRY":"Bahamas",
        "A2":"BS",
        "A3":"BHS",
        "NUM":44,
        "DIALINGCODE":"1-242"
    },
    {
        "COUNTRY":"Bahrain",
        "A2":"BH",
        "A3":"BHR",
        "NUM":48,
        "DIALINGCODE":"973"
    },
    {
        "COUNTRY":"Bangladesh",
        "A2":"BD",
        "A3":"BGD",
        "NUM":50,
        "DIALINGCODE":"880"
    },
    {
        "COUNTRY":"Barbados",
        "A2":"BB",
        "A3":"BRB",
        "NUM":52,
        "DIALINGCODE":"1-246"
    },
    {
        "COUNTRY":"Belarus",
        "A2":"BY",
        "A3":"BLR",
        "NUM":112,
        "DIALINGCODE":"375"
    },
    {
        "COUNTRY":"Belgium",
        "A2":"BE",
        "A3":"BEL",
        "NUM":56,
        "DIALINGCODE":"32"
    },
    {
        "COUNTRY":"Belize",
        "A2":"BZ",
        "A3":"BLZ",
        "NUM":84,
        "DIALINGCODE":"501"
    },
    {
        "COUNTRY":"Benin",
        "A2":"BJ",
        "A3":"BEN",
        "NUM":204,
        "DIALINGCODE":"229"
    },
    {
        "COUNTRY":"Bermuda",
        "A2":"BM",
        "A3":"BMU",
        "NUM":60,
        "DIALINGCODE":"1-441"
    },
    {
        "COUNTRY":"Bhutan",
        "A2":"BT",
        "A3":"BTN",
        "NUM":64,
        "DIALINGCODE":"975"
    },
    {
        "COUNTRY":"Bolivia",
        "A2":"BO",
        "A3":"BOL",
        "NUM":68,
        "DIALINGCODE":"591"
    },
    {
        "COUNTRY":"Bonaire",
        "A2":"BQ",
        "A3":"BES",
        "NUM":535,
        "DIALINGCODE":"599"
    },
    {
        "COUNTRY":"Bosnia and Herzegovina",
        "A2":"BA",
        "A3":"BIH",
        "NUM":70,
        "DIALINGCODE":"387"
    },
    {
        "COUNTRY":"Botswana",
        "A2":"BW",
        "A3":"BWA",
        "NUM":72,
        "DIALINGCODE":"267"
    },
    {
        "COUNTRY":"Bouvet Island",
        "A2":"BV",
        "A3":"BVT",
        "NUM":74,
        "DIALINGCODE":"47"
    },
    {
        "COUNTRY":"Brazil",
        "A2":"BR",
        "A3":"BRA",
        "NUM":76,
        "DIALINGCODE":"55"
    },
    {
        "COUNTRY":"British Indian Ocean Territory",
        "A2":"IO",
        "A3":"IOT",
        "NUM":86,
        "DIALINGCODE":"246"
    },
    {
        "COUNTRY":"Brunei Darussalam",
        "A2":"BN",
        "A3":"BRN",
        "NUM":96,
        "DIALINGCODE":"673"
    },
    {
        "COUNTRY":"Bulgaria",
        "A2":"BG",
        "A3":"BGR",
        "NUM":100,
        "DIALINGCODE":"359"
    },
    {
        "COUNTRY":"Burkina Faso",
        "A2":"BF",
        "A3":"BFA",
        "NUM":854,
        "DIALINGCODE":"226"
    },
    {
        "COUNTRY":"Burundi",
        "A2":"BI",
        "A3":"BDI",
        "NUM":108,
        "DIALINGCODE":"257"
    },
    {
        "COUNTRY":"Cambodia",
        "A2":"KH",
        "A3":"KHM",
        "NUM":116,
        "DIALINGCODE":"855"
    },
    {
        "COUNTRY":"Cameroon",
        "A2":"CM",
        "A3":"CMR",
        "NUM":120,
        "DIALINGCODE":"237"
    },
    {
        "COUNTRY":"Canada",
        "A2":"CA",
        "A3":"CAN",
        "NUM":124,
        "DIALINGCODE":"1"
    },
    {
        "COUNTRY":"Cape Verde",
        "A2":"CV",
        "A3":"CPV",
        "NUM":132,
        "DIALINGCODE":"238"
    },
    {
        "COUNTRY":"Cayman Islands",
        "A2":"KY",
        "A3":"CYM",
        "NUM":136,
        "DIALINGCODE":"1-345"
    },
    {
        "COUNTRY":"Central African Republic",
        "A2":"CF",
        "A3":"CAF",
        "NUM":140,
        "DIALINGCODE":"236"
    },
    {
        "COUNTRY":"Chad",
        "A2":"TD",
        "A3":"TCD",
        "NUM":148,
        "DIALINGCODE":"235"
    },
    {
        "COUNTRY":"Chile",
        "A2":"CL",
        "A3":"CHL",
        "NUM":152,
        "DIALINGCODE":"56"
    },
    {
        "COUNTRY":"China",
        "A2":"CN",
        "A3":"CHN",
        "NUM":156,
        "DIALINGCODE":"86"
    },
    {
        "COUNTRY":"Christmas Island",
        "A2":"CX",
        "A3":"CXR",
        "NUM":162,
        "DIALINGCODE":"61"
    },
    {
        "COUNTRY":"Cocos (Keeling) Islands",
        "A2":"CC",
        "A3":"CCK",
        "NUM":166,
        "DIALINGCODE":"61"
    },
    {
        "COUNTRY":"Colombia",
        "A2":"CO",
        "A3":"COL",
        "NUM":170,
        "DIALINGCODE":"57"
    },
    {
        "COUNTRY":"Comoros",
        "A2":"KM",
        "A3":"COM",
        "NUM":174,
        "DIALINGCODE":"269"
    },
    {
        "COUNTRY":"Congo",
        "A2":"CG",
        "A3":"COG",
        "NUM":178,
        "DIALINGCODE":"242"
    },
    {
        "COUNTRY":"Democratic Republic of the Congo",
        "A2":"CD",
        "A3":"COD",
        "NUM":180,
        "DIALINGCODE":"243"
    },
    {
        "COUNTRY":"Cook Islands",
        "A2":"CK",
        "A3":"COK",
        "NUM":184,
        "DIALINGCODE":"682"
    },
    {
        "COUNTRY":"Costa Rica",
        "A2":"CR",
        "A3":"CRI",
        "NUM":188,
        "DIALINGCODE":"506"
    },
    {
        "COUNTRY":"Croatia",
        "A2":"HR",
        "A3":"HRV",
        "NUM":191,
        "DIALINGCODE":"385"
    },
    {
        "COUNTRY":"Cuba",
        "A2":"CU",
        "A3":"CUB",
        "NUM":192,
        "DIALINGCODE":"53"
    },
    {
        "COUNTRY":"Curacao",
        "A2":"CW",
        "A3":"CUW",
        "NUM":531,
        "DIALINGCODE":"599"
    },
    {
        "COUNTRY":"Cyprus",
        "A2":"CY",
        "A3":"CYP",
        "NUM":196,
        "DIALINGCODE":"357"
    },
    {
        "COUNTRY":"Czech Republic",
        "A2":"CZ",
        "A3":"CZE",
        "NUM":203,
        "DIALINGCODE":"420"
    },
    {
        "COUNTRY":"Cote d'Ivoire",
        "A2":"CI",
        "A3":"CIV",
        "NUM":384,
        "DIALINGCODE":"225"
    },
    {
        "COUNTRY":"Denmark",
        "A2":"DK",
        "A3":"DNK",
        "NUM":208,
        "DIALINGCODE":"45"
    },
    {
        "COUNTRY":"Djibouti",
        "A2":"DJ",
        "A3":"DJI",
        "NUM":262,
        "DIALINGCODE":"253"
    },
    {
        "COUNTRY":"Dominica",
        "A2":"DM",
        "A3":"DMA",
        "NUM":212,
        "DIALINGCODE":"1-767"
    },
    {
        "COUNTRY":"Dominican Republic",
        "A2":"DO",
        "A3":"DOM",
        "NUM":214,
        "DIALINGCODE":"1-809,1-829,1-849"
    },
    {
        "COUNTRY":"Ecuador",
        "A2":"EC",
        "A3":"ECU",
        "NUM":218,
        "DIALINGCODE":"593"
    },
    {
        "COUNTRY":"Egypt",
        "A2":"EG",
        "A3":"EGY",
        "NUM":818,
        "DIALINGCODE":"20"
    },
    {
        "COUNTRY":"El Salvador",
        "A2":"SV",
        "A3":"SLV",
        "NUM":222,
        "DIALINGCODE":"503"
    },
    {
        "COUNTRY":"Equatorial Guinea",
        "A2":"GQ",
        "A3":"GNQ",
        "NUM":226,
        "DIALINGCODE":"240"
    },
    {
        "COUNTRY":"Eritrea",
        "A2":"ER",
        "A3":"ERI",
        "NUM":232,
        "DIALINGCODE":"291"
    },
    {
        "COUNTRY":"Estonia",
        "A2":"EE",
        "A3":"EST",
        "NUM":233,
        "DIALINGCODE":"372"
    },
    {
        "COUNTRY":"Ethiopia",
        "A2":"ET",
        "A3":"ETH",
        "NUM":231,
        "DIALINGCODE":"251"
    },
    {
        "COUNTRY":"Falkland Islands (Malvinas)",
        "A2":"FK",
        "A3":"FLK",
        "NUM":238,
        "DIALINGCODE":"500"
    },
    {
        "COUNTRY":"Faroe Islands",
        "A2":"FO",
        "A3":"FRO",
        "NUM":234,
        "DIALINGCODE":"298"
    },
    {
        "COUNTRY":"Fiji",
        "A2":"FJ",
        "A3":"FJI",
        "NUM":242,
        "DIALINGCODE":"679"
    },
    {
        "COUNTRY":"Finland",
        "A2":"FI",
        "A3":"FIN",
        "NUM":246,
        "DIALINGCODE":"358"
    },
    {
        "COUNTRY":"France",
        "A2":"FR",
        "A3":"FRA",
        "NUM":250,
        "DIALINGCODE":"33"
    },
    {
        "COUNTRY":"French Guiana",
        "A2":"GF",
        "A3":"GUF",
        "NUM":254,
        "DIALINGCODE":"594"
    },
    {
        "COUNTRY":"French Polynesia",
        "A2":"PF",
        "A3":"PYF",
        "NUM":258,
        "DIALINGCODE":"689"
    },
    {
        "COUNTRY":"French Southern Territories",
        "A2":"TF",
        "A3":"ATF",
        "NUM":260,
        "DIALINGCODE":"262"
    },
    {
        "COUNTRY":"Gabon",
        "A2":"GA",
        "A3":"GAB",
        "NUM":266,
        "DIALINGCODE":"241"
    },
    {
        "COUNTRY":"Gambia",
        "A2":"GM",
        "A3":"GMB",
        "NUM":270,
        "DIALINGCODE":"220"
    },
    {
        "COUNTRY":"Georgia",
        "A2":"GE",
        "A3":"GEO",
        "NUM":268,
        "DIALINGCODE":"995"
    },
    {
        "COUNTRY":"Germany",
        "A2":"DE",
        "A3":"DEU",
        "NUM":276,
        "DIALINGCODE":"49"
    },
    {
        "COUNTRY":"Ghana",
        "A2":"GH",
        "A3":"GHA",
        "NUM":288,
        "DIALINGCODE":"233"
    },
    {
        "COUNTRY":"Gibraltar",
        "A2":"GI",
        "A3":"GIB",
        "NUM":292,
        "DIALINGCODE":"350"
    },
    {
        "COUNTRY":"Greece",
        "A2":"GR",
        "A3":"GRC",
        "NUM":300,
        "DIALINGCODE":"30"
    },
    {
        "COUNTRY":"Greenland",
        "A2":"GL",
        "A3":"GRL",
        "NUM":304,
        "DIALINGCODE":"299"
    },
    {
        "COUNTRY":"Grenada",
        "A2":"GD",
        "A3":"GRD",
        "NUM":308,
        "DIALINGCODE":"1-473"
    },
    {
        "COUNTRY":"Guadeloupe",
        "A2":"GP",
        "A3":"GLP",
        "NUM":312,
        "DIALINGCODE":"590"
    },
    {
        "COUNTRY":"Guam",
        "A2":"GU",
        "A3":"GUM",
        "NUM":316,
        "DIALINGCODE":"1-671"
    },
    {
        "COUNTRY":"Guatemala",
        "A2":"GT",
        "A3":"GTM",
        "NUM":320,
        "DIALINGCODE":"502"
    },
    {
        "COUNTRY":"Guernsey",
        "A2":"GG",
        "A3":"GGY",
        "NUM":831,
        "DIALINGCODE":"44"
    },
    {
        "COUNTRY":"Guinea",
        "A2":"GN",
        "A3":"GIN",
        "NUM":324,
        "DIALINGCODE":"224"
    },
    {
        "COUNTRY":"Guinea-Bissau",
        "A2":"GW",
        "A3":"GNB",
        "NUM":624,
        "DIALINGCODE":"245"
    },
    {
        "COUNTRY":"Guyana",
        "A2":"GY",
        "A3":"GUY",
        "NUM":328,
        "DIALINGCODE":"592"
    },
    {
        "COUNTRY":"Haiti",
        "A2":"HT",
        "A3":"HTI",
        "NUM":332,
        "DIALINGCODE":"509"
    },
    {
        "COUNTRY":"Heard Island and McDonald\u00a0Islands",
        "A2":"HM",
        "A3":"HMD",
        "NUM":334,
        "DIALINGCODE":"672"
    },
    {
        "COUNTRY":"Holy See (Vatican City State)",
        "A2":"VA",
        "A3":"VAT",
        "NUM":336,
        "DIALINGCODE":"379"
    },
    {
        "COUNTRY":"Honduras",
        "A2":"HN",
        "A3":"HND",
        "NUM":340,
        "DIALINGCODE":"504"
    },
    {
        "COUNTRY":"Hong Kong",
        "A2":"HK",
        "A3":"HKG",
        "NUM":344,
        "DIALINGCODE":"852"
    },
    {
        "COUNTRY":"Hungary",
        "A2":"HU",
        "A3":"HUN",
        "NUM":348,
        "DIALINGCODE":"36"
    },
    {
        "COUNTRY":"Iceland",
        "A2":"IS",
        "A3":"ISL",
        "NUM":352,
        "DIALINGCODE":"354"
    },
    {
        "COUNTRY":"India",
        "A2":"IN",
        "A3":"IND",
        "NUM":356,
        "DIALINGCODE":"91"
    },
    {
        "COUNTRY":"Indonesia",
        "A2":"ID",
        "A3":"IDN",
        "NUM":360,
        "DIALINGCODE":"62"
    },
    {
        "COUNTRY":"Iran, Islamic Republic of",
        "A2":"IR",
        "A3":"IRN",
        "NUM":364,
        "DIALINGCODE":"98"
    },
    {
        "COUNTRY":"Iraq",
        "A2":"IQ",
        "A3":"IRQ",
        "NUM":368,
        "DIALINGCODE":"964"
    },
    {
        "COUNTRY":"Ireland",
        "A2":"IE",
        "A3":"IRL",
        "NUM":372,
        "DIALINGCODE":"353"
    },
    {
        "COUNTRY":"Isle of Man",
        "A2":"IM",
        "A3":"IMN",
        "NUM":833,
        "DIALINGCODE":"44"
    },
    {
        "COUNTRY":"Israel",
        "A2":"IL",
        "A3":"ISR",
        "NUM":376,
        "DIALINGCODE":"972"
    },
    {
        "COUNTRY":"Italy",
        "A2":"IT",
        "A3":"ITA",
        "NUM":380,
        "DIALINGCODE":"39"
    },
    {
        "COUNTRY":"Jamaica",
        "A2":"JM",
        "A3":"JAM",
        "NUM":388,
        "DIALINGCODE":"1-876"
    },
    {
        "COUNTRY":"Japan",
        "A2":"JP",
        "A3":"JPN",
        "NUM":392,
        "DIALINGCODE":"81"
    },
    {
        "COUNTRY":"Jersey",
        "A2":"JE",
        "A3":"JEY",
        "NUM":832,
        "DIALINGCODE":"44"
    },
    {
        "COUNTRY":"Jordan",
        "A2":"JO",
        "A3":"JOR",
        "NUM":400,
        "DIALINGCODE":"962"
    },
    {
        "COUNTRY":"Kazakhstan",
        "A2":"KZ",
        "A3":"KAZ",
        "NUM":398,
        "DIALINGCODE":"7"
    },
    {
        "COUNTRY":"Kenya",
        "A2":"KE",
        "A3":"KEN",
        "NUM":404,
        "DIALINGCODE":"254"
    },
    {
        "COUNTRY":"Kiribati",
        "A2":"KI",
        "A3":"KIR",
        "NUM":296,
        "DIALINGCODE":"686"
    },
    {
        "COUNTRY":"Korea, Democratic People's Republic of",
        "A2":"KP",
        "A3":"PRK",
        "NUM":408,
        "DIALINGCODE":"850"
    },
    {
        "COUNTRY":"Korea, Republic of",
        "A2":"KR",
        "A3":"KOR",
        "NUM":410,
        "DIALINGCODE":"82"
    },
    {
        "COUNTRY":"Kuwait",
        "A2":"KW",
        "A3":"KWT",
        "NUM":414,
        "DIALINGCODE":"965"
    },
    {
        "COUNTRY":"Kyrgyzstan",
        "A2":"KG",
        "A3":"KGZ",
        "NUM":417,
        "DIALINGCODE":"996"
    },
    {
        "COUNTRY":"Lao People's Democratic Republic",
        "A2":"LA",
        "A3":"LAO",
        "NUM":418,
        "DIALINGCODE":"856"
    },
    {
        "COUNTRY":"Latvia",
        "A2":"LV",
        "A3":"LVA",
        "NUM":428,
        "DIALINGCODE":"371"
    },
    {
        "COUNTRY":"Lebanon",
        "A2":"LB",
        "A3":"LBN",
        "NUM":422,
        "DIALINGCODE":"961"
    },
    {
        "COUNTRY":"Lesotho",
        "A2":"LS",
        "A3":"LSO",
        "NUM":426,
        "DIALINGCODE":"266"
    },
    {
        "COUNTRY":"Liberia",
        "A2":"LR",
        "A3":"LBR",
        "NUM":430,
        "DIALINGCODE":"231"
    },
    {
        "COUNTRY":"Libya",
        "A2":"LY",
        "A3":"LBY",
        "NUM":434,
        "DIALINGCODE":"218"
    },
    {
        "COUNTRY":"Liechtenstein",
        "A2":"LI",
        "A3":"LIE",
        "NUM":438,
        "DIALINGCODE":"423"
    },
    {
        "COUNTRY":"Lithuania",
        "A2":"LT",
        "A3":"LTU",
        "NUM":440,
        "DIALINGCODE":"370"
    },
    {
        "COUNTRY":"Luxembourg",
        "A2":"LU",
        "A3":"LUX",
        "NUM":442,
        "DIALINGCODE":"352"
    },
    {
        "COUNTRY":"Macao",
        "A2":"MO",
        "A3":"MAC",
        "NUM":446,
        "DIALINGCODE":"853"
    },
    {
        "COUNTRY":"Macedonia, the Former Yugoslav Republic of",
        "A2":"MK",
        "A3":"MKD",
        "NUM":807,
        "DIALINGCODE":"389"
    },
    {
        "COUNTRY":"Madagascar",
        "A2":"MG",
        "A3":"MDG",
        "NUM":450,
        "DIALINGCODE":"261"
    },
    {
        "COUNTRY":"Malawi",
        "A2":"MW",
        "A3":"MWI",
        "NUM":454,
        "DIALINGCODE":"265"
    },
    {
        "COUNTRY":"Malaysia",
        "A2":"MY",
        "A3":"MYS",
        "NUM":458,
        "DIALINGCODE":"60"
    },
    {
        "COUNTRY":"Maldives",
        "A2":"MV",
        "A3":"MDV",
        "NUM":462,
        "DIALINGCODE":"960"
    },
    {
        "COUNTRY":"Mali",
        "A2":"ML",
        "A3":"MLI",
        "NUM":466,
        "DIALINGCODE":"223"
    },
    {
        "COUNTRY":"Malta",
        "A2":"MT",
        "A3":"MLT",
        "NUM":470,
        "DIALINGCODE":"356"
    },
    {
        "COUNTRY":"Marshall Islands",
        "A2":"MH",
        "A3":"MHL",
        "NUM":584,
        "DIALINGCODE":"692"
    },
    {
        "COUNTRY":"Martinique",
        "A2":"MQ",
        "A3":"MTQ",
        "NUM":474,
        "DIALINGCODE":"596"
    },
    {
        "COUNTRY":"Mauritania",
        "A2":"MR",
        "A3":"MRT",
        "NUM":478,
        "DIALINGCODE":"222"
    },
    {
        "COUNTRY":"Mauritius",
        "A2":"MU",
        "A3":"MUS",
        "NUM":480,
        "DIALINGCODE":"230"
    },
    {
        "COUNTRY":"Mayotte",
        "A2":"YT",
        "A3":"MYT",
        "NUM":175,
        "DIALINGCODE":"262"
    },
    {
        "COUNTRY":"Mexico",
        "A2":"MX",
        "A3":"MEX",
        "NUM":484,
        "DIALINGCODE":"52"
    },
    {
        "COUNTRY":"Micronesia, Federated States of",
        "A2":"FM",
        "A3":"FSM",
        "NUM":583,
        "DIALINGCODE":"691"
    },
    {
        "COUNTRY":"Moldova, Republic of",
        "A2":"MD",
        "A3":"MDA",
        "NUM":498,
        "DIALINGCODE":"373"
    },
    {
        "COUNTRY":"Monaco",
        "A2":"MC",
        "A3":"MCO",
        "NUM":492,
        "DIALINGCODE":"377"
    },
    {
        "COUNTRY":"Mongolia",
        "A2":"MN",
        "A3":"MNG",
        "NUM":496,
        "DIALINGCODE":"976"
    },
    {
        "COUNTRY":"Montenegro",
        "A2":"ME",
        "A3":"MNE",
        "NUM":499,
        "DIALINGCODE":"382"
    },
    {
        "COUNTRY":"Montserrat",
        "A2":"MS",
        "A3":"MSR",
        "NUM":500,
        "DIALINGCODE":"1-664"
    },
    {
        "COUNTRY":"Morocco",
        "A2":"MA",
        "A3":"MAR",
        "NUM":504,
        "DIALINGCODE":"212"
    },
    {
        "COUNTRY":"Mozambique",
        "A2":"MZ",
        "A3":"MOZ",
        "NUM":508,
        "DIALINGCODE":"258"
    },
    {
        "COUNTRY":"Myanmar",
        "A2":"MM",
        "A3":"MMR",
        "NUM":104,
        "DIALINGCODE":"95"
    },
    {
        "COUNTRY":"Namibia",
        "A2":null,
        "A3":"NAM",
        "NUM":516,
        "DIALINGCODE":"264"
    },
    {
        "COUNTRY":"Nauru",
        "A2":"NR",
        "A3":"NRU",
        "NUM":520,
        "DIALINGCODE":"674"
    },
    {
        "COUNTRY":"Nepal",
        "A2":"NP",
        "A3":"NPL",
        "NUM":524,
        "DIALINGCODE":"977"
    },
    {
        "COUNTRY":"Netherlands",
        "A2":"NL",
        "A3":"NLD",
        "NUM":528,
        "DIALINGCODE":"31"
    },
    {
        "COUNTRY":"New Caledonia",
        "A2":"NC",
        "A3":"NCL",
        "NUM":540,
        "DIALINGCODE":"687"
    },
    {
        "COUNTRY":"New Zealand",
        "A2":"NZ",
        "A3":"NZL",
        "NUM":554,
        "DIALINGCODE":"64"
    },
    {
        "COUNTRY":"Nicaragua",
        "A2":"NI",
        "A3":"NIC",
        "NUM":558,
        "DIALINGCODE":"505"
    },
    {
        "COUNTRY":"Niger",
        "A2":"NE",
        "A3":"NER",
        "NUM":562,
        "DIALINGCODE":"227"
    },
    {
        "COUNTRY":"Nigeria",
        "A2":"NG",
        "A3":"NGA",
        "NUM":566,
        "DIALINGCODE":"234"
    },
    {
        "COUNTRY":"Niue",
        "A2":"NU",
        "A3":"NIU",
        "NUM":570,
        "DIALINGCODE":"683"
    },
    {
        "COUNTRY":"Norfolk Island",
        "A2":"NF",
        "A3":"NFK",
        "NUM":574,
        "DIALINGCODE":"672"
    },
    {
        "COUNTRY":"Northern Mariana Islands",
        "A2":"MP",
        "A3":"MNP",
        "NUM":580,
        "DIALINGCODE":"1-670"
    },
    {
        "COUNTRY":"Norway",
        "A2":"NO",
        "A3":"NOR",
        "NUM":578,
        "DIALINGCODE":"47"
    },
    {
        "COUNTRY":"Oman",
        "A2":"OM",
        "A3":"OMN",
        "NUM":512,
        "DIALINGCODE":"968"
    },
    {
        "COUNTRY":"Pakistan",
        "A2":"PK",
        "A3":"PAK",
        "NUM":586,
        "DIALINGCODE":"92"
    },
    {
        "COUNTRY":"Palau",
        "A2":"PW",
        "A3":"PLW",
        "NUM":585,
        "DIALINGCODE":"680"
    },
    {
        "COUNTRY":"Palestine, State of",
        "A2":"PS",
        "A3":"PSE",
        "NUM":275,
        "DIALINGCODE":"970"
    },
    {
        "COUNTRY":"Panama",
        "A2":"PA",
        "A3":"PAN",
        "NUM":591,
        "DIALINGCODE":"507"
    },
    {
        "COUNTRY":"Papua New Guinea",
        "A2":"PG",
        "A3":"PNG",
        "NUM":598,
        "DIALINGCODE":"675"
    },
    {
        "COUNTRY":"Paraguay",
        "A2":"PY",
        "A3":"PRY",
        "NUM":600,
        "DIALINGCODE":"595"
    },
    {
        "COUNTRY":"Peru",
        "A2":"PE",
        "A3":"PER",
        "NUM":604,
        "DIALINGCODE":"51"
    },
    {
        "COUNTRY":"Philippines",
        "A2":"PH",
        "A3":"PHL",
        "NUM":608,
        "DIALINGCODE":"63"
    },
    {
        "COUNTRY":"Pitcairn",
        "A2":"PN",
        "A3":"PCN",
        "NUM":612,
        "DIALINGCODE":"870"
    },
    {
        "COUNTRY":"Poland",
        "A2":"PL",
        "A3":"POL",
        "NUM":616,
        "DIALINGCODE":"48"
    },
    {
        "COUNTRY":"Portugal",
        "A2":"PT",
        "A3":"PRT",
        "NUM":620,
        "DIALINGCODE":"351"
    },
    {
        "COUNTRY":"Puerto Rico",
        "A2":"PR",
        "A3":"PRI",
        "NUM":630,
        "DIALINGCODE":"1"
    },
    {
        "COUNTRY":"Qatar",
        "A2":"QA",
        "A3":"QAT",
        "NUM":634,
        "DIALINGCODE":"974"
    },
    {
        "COUNTRY":"Romania",
        "A2":"RO",
        "A3":"ROU",
        "NUM":642,
        "DIALINGCODE":"40"
    },
    {
        "COUNTRY":"Russian Federation",
        "A2":"RU",
        "A3":"RUS",
        "NUM":643,
        "DIALINGCODE":"7"
    },
    {
        "COUNTRY":"Rwanda",
        "A2":"RW",
        "A3":"RWA",
        "NUM":646,
        "DIALINGCODE":"250"
    },
    {
        "COUNTRY":"Reunion",
        "A2":"RE",
        "A3":"REU",
        "NUM":638,
        "DIALINGCODE":"262"
    },
    {
        "COUNTRY":"Saint Barthelemy",
        "A2":"BL",
        "A3":"BLM",
        "NUM":652,
        "DIALINGCODE":"590"
    },
    {
        "COUNTRY":"Saint Helena",
        "A2":"SH",
        "A3":"SHN",
        "NUM":654,
        "DIALINGCODE":"290"
    },
    {
        "COUNTRY":"Saint Kitts and Nevis",
        "A2":"KN",
        "A3":"KNA",
        "NUM":659,
        "DIALINGCODE":"1-869"
    },
    {
        "COUNTRY":"Saint Lucia",
        "A2":"LC",
        "A3":"LCA",
        "NUM":662,
        "DIALINGCODE":"1-758"
    },
    {
        "COUNTRY":"Saint Martin (French part)",
        "A2":"MF",
        "A3":"MAF",
        "NUM":663,
        "DIALINGCODE":"590"
    },
    {
        "COUNTRY":"Saint Pierre and Miquelon",
        "A2":"PM",
        "A3":"SPM",
        "NUM":666,
        "DIALINGCODE":"508"
    },
    {
        "COUNTRY":"Saint Vincent and the Grenadines",
        "A2":"VC",
        "A3":"VCT",
        "NUM":670,
        "DIALINGCODE":"1-784"
    },
    {
        "COUNTRY":"Samoa",
        "A2":"WS",
        "A3":"WSM",
        "NUM":882,
        "DIALINGCODE":"685"
    },
    {
        "COUNTRY":"San Marino",
        "A2":"SM",
        "A3":"SMR",
        "NUM":674,
        "DIALINGCODE":"378"
    },
    {
        "COUNTRY":"Sao Tome and Principe",
        "A2":"ST",
        "A3":"STP",
        "NUM":678,
        "DIALINGCODE":"239"
    },
    {
        "COUNTRY":"Saudi Arabia",
        "A2":"SA",
        "A3":"SAU",
        "NUM":682,
        "DIALINGCODE":"966"
    },
    {
        "COUNTRY":"Senegal",
        "A2":"SN",
        "A3":"SEN",
        "NUM":686,
        "DIALINGCODE":"221"
    },
    {
        "COUNTRY":"Serbia",
        "A2":"RS",
        "A3":"SRB",
        "NUM":688,
        "DIALINGCODE":"381"
    },
    {
        "COUNTRY":"Seychelles",
        "A2":"SC",
        "A3":"SYC",
        "NUM":690,
        "DIALINGCODE":"248"
    },
    {
        "COUNTRY":"Sierra Leone",
        "A2":"SL",
        "A3":"SLE",
        "NUM":694,
        "DIALINGCODE":"232"
    },
    {
        "COUNTRY":"Singapore",
        "A2":"SG",
        "A3":"SGP",
        "NUM":702,
        "DIALINGCODE":"65"
    },
    {
        "COUNTRY":"Sint Maarten (Dutch part)",
        "A2":"SX",
        "A3":"SXM",
        "NUM":534,
        "DIALINGCODE":"1-721"
    },
    {
        "COUNTRY":"Slovakia",
        "A2":"SK",
        "A3":"SVK",
        "NUM":703,
        "DIALINGCODE":"421"
    },
    {
        "COUNTRY":"Slovenia",
        "A2":"SI",
        "A3":"SVN",
        "NUM":705,
        "DIALINGCODE":"386"
    },
    {
        "COUNTRY":"Solomon Islands",
        "A2":"SB",
        "A3":"SLB",
        "NUM":90,
        "DIALINGCODE":"677"
    },
    {
        "COUNTRY":"Somalia",
        "A2":"SO",
        "A3":"SOM",
        "NUM":706,
        "DIALINGCODE":"252"
    },
    {
        "COUNTRY":"South Africa",
        "A2":"ZA",
        "A3":"ZAF",
        "NUM":710,
        "DIALINGCODE":"27"
    },
    {
        "COUNTRY":"South Georgia and the South Sandwich Islands",
        "A2":"GS",
        "A3":"SGS",
        "NUM":239,
        "DIALINGCODE":"500"
    },
    {
        "COUNTRY":"South Sudan",
        "A2":"SS",
        "A3":"SSD",
        "NUM":728,
        "DIALINGCODE":"211"
    },
    {
        "COUNTRY":"Spain",
        "A2":"ES",
        "A3":"ESP",
        "NUM":724,
        "DIALINGCODE":"34"
    },
    {
        "COUNTRY":"Sri Lanka",
        "A2":"LK",
        "A3":"LKA",
        "NUM":144,
        "DIALINGCODE":"94"
    },
    {
        "COUNTRY":"Sudan",
        "A2":"SD",
        "A3":"SDN",
        "NUM":729,
        "DIALINGCODE":"249"
    },
    {
        "COUNTRY":"Suriname",
        "A2":"SR",
        "A3":"SUR",
        "NUM":740,
        "DIALINGCODE":"597"
    },
    {
        "COUNTRY":"Svalbard and Jan Mayen",
        "A2":"SJ",
        "A3":"SJM",
        "NUM":744,
        "DIALINGCODE":"47"
    },
    {
        "COUNTRY":"Swaziland",
        "A2":"SZ",
        "A3":"SWZ",
        "NUM":748,
        "DIALINGCODE":"268"
    },
    {
        "COUNTRY":"Sweden",
        "A2":"SE",
        "A3":"SWE",
        "NUM":752,
        "DIALINGCODE":"46"
    },
    {
        "COUNTRY":"Switzerland",
        "A2":"CH",
        "A3":"CHE",
        "NUM":756,
        "DIALINGCODE":"41"
    },
    {
        "COUNTRY":"Syrian Arab Republic",
        "A2":"SY",
        "A3":"SYR",
        "NUM":760,
        "DIALINGCODE":"963"
    },
    {
        "COUNTRY":"Taiwan",
        "A2":"TW",
        "A3":"TWN",
        "NUM":158,
        "DIALINGCODE":"886"
    },
    {
        "COUNTRY":"Tajikistan",
        "A2":"TJ",
        "A3":"TJK",
        "NUM":762,
        "DIALINGCODE":"992"
    },
    {
        "COUNTRY":"United Republic of Tanzania",
        "A2":"TZ",
        "A3":"TZA",
        "NUM":834,
        "DIALINGCODE":"255"
    },
    {
        "COUNTRY":"Thailand",
        "A2":"TH",
        "A3":"THA",
        "NUM":764,
        "DIALINGCODE":"66"
    },
    {
        "COUNTRY":"Timor-Leste",
        "A2":"TL",
        "A3":"TLS",
        "NUM":626,
        "DIALINGCODE":"670"
    },
    {
        "COUNTRY":"Togo",
        "A2":"TG",
        "A3":"TGO",
        "NUM":768,
        "DIALINGCODE":"228"
    },
    {
        "COUNTRY":"Tokelau",
        "A2":"TK",
        "A3":"TKL",
        "NUM":772,
        "DIALINGCODE":"690"
    },
    {
        "COUNTRY":"Tonga",
        "A2":"TO",
        "A3":"TON",
        "NUM":776,
        "DIALINGCODE":"676"
    },
    {
        "COUNTRY":"Trinidad and Tobago",
        "A2":"TT",
        "A3":"TTO",
        "NUM":780,
        "DIALINGCODE":"1-868"
    },
    {
        "COUNTRY":"Tunisia",
        "A2":"TN",
        "A3":"TUN",
        "NUM":788,
        "DIALINGCODE":"216"
    },
    {
        "COUNTRY":"Turkey",
        "A2":"TR",
        "A3":"TUR",
        "NUM":792,
        "DIALINGCODE":"90"
    },
    {
        "COUNTRY":"Turkmenistan",
        "A2":"TM",
        "A3":"TKM",
        "NUM":795,
        "DIALINGCODE":"993"
    },
    {
        "COUNTRY":"Turks and Caicos Islands",
        "A2":"TC",
        "A3":"TCA",
        "NUM":796,
        "DIALINGCODE":"1-649"
    },
    {
        "COUNTRY":"Tuvalu",
        "A2":"TV",
        "A3":"TUV",
        "NUM":798,
        "DIALINGCODE":"688"
    },
    {
        "COUNTRY":"Uganda",
        "A2":"UG",
        "A3":"UGA",
        "NUM":800,
        "DIALINGCODE":"256"
    },
    {
        "COUNTRY":"Ukraine",
        "A2":"UA",
        "A3":"UKR",
        "NUM":804,
        "DIALINGCODE":"380"
    },
    {
        "COUNTRY":"United Arab Emirates",
        "A2":"AE",
        "A3":"ARE",
        "NUM":784,
        "DIALINGCODE":"971"
    },
    {
        "COUNTRY":"United Kingdom",
        "A2":"GB",
        "A3":"GBR",
        "NUM":826,
        "DIALINGCODE":"44"
    },
    {
        "COUNTRY":"United States",
        "A2":"US",
        "A3":"USA",
        "NUM":840,
        "DIALINGCODE":"1"
    },
    {
        "COUNTRY":"United States Minor Outlying Islands",
        "A2":"UM",
        "A3":"UMI",
        "NUM":581,
        "DIALINGCODE":"1"
    },
    {
        "COUNTRY":"Uruguay",
        "A2":"UY",
        "A3":"URY",
        "NUM":858,
        "DIALINGCODE":"598"
    },
    {
        "COUNTRY":"Uzbekistan",
        "A2":"UZ",
        "A3":"UZB",
        "NUM":860,
        "DIALINGCODE":"998"
    },
    {
        "COUNTRY":"Vanuatu",
        "A2":"VU",
        "A3":"VUT",
        "NUM":548,
        "DIALINGCODE":"678"
    },
    {
        "COUNTRY":"Venezuela",
        "A2":"VE",
        "A3":"VEN",
        "NUM":862,
        "DIALINGCODE":"58"
    },
    {
        "COUNTRY":"Viet Nam",
        "A2":"VN",
        "A3":"VNM",
        "NUM":704,
        "DIALINGCODE":"84"
    },
    {
        "COUNTRY":"British Virgin Islands",
        "A2":"VG",
        "A3":"VGB",
        "NUM":92,
        "DIALINGCODE":"1-284"
    },
    {
        "COUNTRY":"US Virgin Islands",
        "A2":"VI",
        "A3":"VIR",
        "NUM":850,
        "DIALINGCODE":"1-340"
    },
    {
        "COUNTRY":"Wallis and Futuna",
        "A2":"WF",
        "A3":"WLF",
        "NUM":876,
        "DIALINGCODE":"681"
    },
    {
        "COUNTRY":"Western Sahara",
        "A2":"EH",
        "A3":"ESH",
        "NUM":732,
        "DIALINGCODE":"212"
    },
    {
        "COUNTRY":"Yemen",
        "A2":"YE",
        "A3":"YEM",
        "NUM":887,
        "DIALINGCODE":"967"
    },
    {
        "COUNTRY":"Zambia",
        "A2":"ZM",
        "A3":"ZMB",
        "NUM":894,
        "DIALINGCODE":"260"
    },
    {
        "COUNTRY":"Zimbabwe",
        "A2":"ZW",
        "A3":"ZWE",
        "NUM":716,
        "DIALINGCODE":"263"
    }
]

export default countries;

